import clsx from 'clsx'
import { MouseEventHandler } from 'react'

import type { DisclosableItemCardHeaderProps } from './type'

import { Image, InputCheckbox } from '@/components/ui'

export const DisclosableItemCardHeader = ({
  item,
  totalOrderCount,
  disabled = false,
  selectable = false,
  selected = false,
  onChangeSelected,
}: DisclosableItemCardHeaderProps) => {
  const handleClickCheckbox: MouseEventHandler<HTMLDivElement> = (event) => {
    event.stopPropagation()
  }

  return (
    <div
      className={clsx(
        'tw-w-full',
        'tw-flex tw-items-center',
        'tw-gap-x-2 tw-p-1'
      )}
    >
      {selectable && (
        <div className={clsx('tw-flex-none')} onClick={handleClickCheckbox}>
          <InputCheckbox
            checked={!!selected}
            label={item.itemName}
            handleChange={(value) =>
              onChangeSelected && onChangeSelected(value, item)
            }
          />
        </div>
      )}
      <div className={clsx('tw-h-11 tw-w-10 lg:tw-h-20 lg:tw-w-20')}>
        <Image src={item.itemImage ?? ''} alt={item.itemName ?? ''} />
      </div>
      <div
        className={clsx(
          'tw-flex-1 tw-text-left tw-text-xs tw-font-bold tw-line-clamp-2'
        )}
      >
        {item.itemName}
      </div>
      <div
        className={clsx(
          'tw-flex tw-h-8 tw-w-16 tw-items-center tw-justify-end tw-px-2',
          'tw-rounded tw-border tw-border-gray-300 tw-text-xs',
          disabled ? 'tw-bg-gray-100' : 'tw-bg-white'
        )}
      >
        {totalOrderCount}
      </div>
    </div>
  )
}
